import { siteMeta, footerLinks, categories } from '@/mocks/content';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-list-2-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              {siteMeta.tagline}，把热门、分类与推荐重新整理，帮助你更高效地找到感兴趣的内容。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-300 cursor-pointer transition-colors hover:text-primary-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <a
                    href="#collections"
                    className="text-sm text-secondary-300 cursor-pointer transition-colors hover:text-primary-300"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">内容说明</h3>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              本站是对网络公开视频与资源的整理与导航，内容版权归原出处所有。若涉及内容调整或更正，欢迎通过页面上的联系方式反馈。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © {new Date().getFullYear()} {siteMeta.name} · 内容整理与导航展示
          </p>
          <p className="text-xs text-secondary-400">仅供信息浏览参考，请遵守各来源平台的使用规则</p>
        </div>
      </div>
    </footer>
  );
}